import { createContext, useContext } from 'react';

export type FieldContextType = {
  'aria-describedby'?: string;
  id: string;
  labelId?: string;
  invalid: boolean;
};

export const FieldContext = createContext<FieldContextType | null>(null);

export function useMaybeFieldContext() {
  return useContext(FieldContext);
}

export function useFieldContext() {
  const ctx = useMaybeFieldContext();

  if (!ctx) {
    throw new Error('Input components must be inside a `Field`.');
  }

  return ctx;
}
